var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_122_2876",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#6A7878"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_122_2876)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9578 14.202L14.202 20.9578C14.0203 21.1384 13.8159 21.274 13.5887 21.3645C13.3616 21.4548 13.1351 21.5 12.9093 21.5C12.6833 21.5 12.4572 21.4548 12.2312 21.3645C12.0052 21.274 11.8019 21.1384 11.6213 20.9578L3.027 12.373C2.8565 12.209 2.726 12.0165 2.6355 11.7955C2.54517 11.5745 2.5 11.342 2.5 11.098V4.31725C2.5 3.81758 2.67658 3.38975 3.02975 3.03375C3.38308 2.67792 3.81225 2.5 4.31725 2.5H11.098C11.3395 2.5 11.5734 2.549 11.7998 2.647C12.0262 2.74483 12.2225 2.87658 12.3885 3.04225L20.9578 11.627C21.1409 11.8087 21.2745 12.013 21.3585 12.24C21.4425 12.4672 21.4845 12.6949 21.4845 12.9233C21.4845 13.1516 21.4425 13.3761 21.3585 13.5968C21.2745 13.8176 21.1409 14.0193 20.9578 14.202ZM13.1328 19.9038L19.8885 13.148C19.9525 13.084 19.9845 13.0087 19.9845 12.922C19.9845 12.8355 19.9525 12.7603 19.8885 12.6962L11.2078 4.0095H4.31725C4.22758 4.0095 4.15225 4.03842 4.09125 4.09625C4.03042 4.15392 4 4.22758 4 4.31725V11.0828C4 11.1213 4.00642 11.1597 4.01925 11.198C4.03208 11.2365 4.0545 11.2718 4.0865 11.3038L12.6808 19.9038C12.7449 19.9679 12.8203 20 12.9068 20C12.9933 20 13.0686 19.9679 13.1328 19.9038ZM6.525 7.77875C6.87367 7.77875 7.16983 7.65725 7.4135 7.41425C7.657 7.17125 7.77875 6.87608 7.77875 6.52875C7.77875 6.17892 7.65725 5.88158 7.41425 5.63675C7.17125 5.39175 6.87608 5.26925 6.52875 5.26925C6.17892 5.26925 5.88158 5.39133 5.63675 5.6355C5.39175 5.87967 5.26925 6.17617 5.26925 6.525C5.26925 6.87367 5.39133 7.16983 5.6355 7.4135C5.87967 7.657 6.17617 7.77875 6.525 7.77875Z",
    fill: "#6A7878"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSell);
export default __webpack_public_path__ + "static/media/sell.32b87a74ac48549c609b0c57a68f3d45.svg";
export { ForwardRef as ReactComponent };